import script from "./periodicTask.vue?vue&type=script&setup=true&lang=js"
export * from "./periodicTask.vue?vue&type=script&setup=true&lang=js"

import "./periodicTask.vue?vue&type=style&index=0&id=c1f0a99a&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f0a99a"]])

export default __exports__